import { SessionStatusFilter } from '@kouto/types';
import toDateString from 'utils/date/toDateString';

const buildSessionsUrl = (
  listingId: string,
  {
    from,
    to,
    resourceGroupId,
    maxSessionsPerDay,
    status,
  }: {
    from: Date;
    to: Date;
    resourceGroupId?: string;
    maxSessionsPerDay?: number;
    status?: SessionStatusFilter;
  },
) => {
  const url = new URL(
    `${process.env.KOUTO_API_URL}/v1/listings/${listingId}/sessions`,
  );
  url.searchParams.set('from', toDateString(from));
  url.searchParams.set('to', toDateString(to));

  if (resourceGroupId) {
    url.searchParams.set('resourceGroupId', resourceGroupId);
  }

  if (maxSessionsPerDay) {
    url.searchParams.set('maxSessionsPerDay', String(maxSessionsPerDay));
  }

  if (status) {
    url.searchParams.set('status', status);
  }

  return url.toString();
};

export default buildSessionsUrl;
